import React from 'react';
import { Link } from "react-router-dom";
import "./rafting.css";
import { FaWater, FaLifeRing, FaMapMarkedAlt } from "react-icons/fa";

function Rafting() {
  const raftingSpots = [
    { name: "Kitulgala", highlight: "Most popular rafting destination in Sri Lanka", image: "/kithul.jpg" },
    { name: "Kelani River", highlight: "Scenic rapids with varying difficulty", image: "/kalani.jpg" },
    { name: "Mahaweli River", highlight: "Longest river rafting route", image: "/mahawali.jpg" },
  ];

  return (
    <div className="bird-page">
      {/* Banner */}
      <div className="banner-section">
        <img src="/rafting.webp" alt="Rafting Adventure" className="banner-image" />
        <div className="banner-content">
          <h1 className="banner-title"><span><b>Water</b></span> Rafting</h1>
          <div className="banner-description">
            <p>Feel the adrenaline rush as you navigate through powerful rapids in Sri Lanka’s rivers. Perfect for thrill-seekers and nature lovers alike.</p>
            <Link to="/booking"><button className="book-now-btn">Book Your Rafting Trip</button></Link>
          </div>
        </div>
      </div>

      {/* Locations */}
      <div className="wildlife-areas-section">
        <h2 className="section-title">Rafting Destinations</h2>
        <p className="section-subtitle">Adventure on the water</p>
        <div className="wildlife-areas-grid">
          {raftingSpots.map((spot, i) => (
            <div className="wildlife-area-card" key={i}>
              <div className="area-image-container">
                <img src={spot.image} alt={spot.name} className="area-image" loading="lazy" />
                <div className="area-overlay"></div>
              </div>
              <div className="area-info">
                <h3>{spot.name}</h3>
                <p>{spot.highlight}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Info Cards */}
      <section className="info-section">
        <div className="info-card"><FaWater className="icon" /><h3 className="desc-heading">Rapid Adventures</h3><p className="desc-para">Experience thrilling river rapids.</p></div>
        <div className="info-card"><FaLifeRing className="icon" /><h3 className="desc-heading">Safety First</h3><p className="desc-para">Professional guides and safety gear included.</p></div>
        <div className="info-card"><FaMapMarkedAlt className="icon" /><h3 className="desc-heading">Top Rivers</h3><p className="desc-para">Raft on Sri Lanka’s most exciting rivers.</p></div>
      </section>

      {/* Quote */}
      <section className="quote-section">
        <blockquote>"A smooth sea never made a skilled sailor."</blockquote>
        <cite>— Franklin D. Roosevelt</cite>
      </section>
    </div>
  );
}

export default Rafting;
